// Styled console message for the curious.
// Pairs with the HTML comment block at the top of default.hbs.
// View Source has the wave + quote, the Console has this.

export default function credits() {
    if (typeof console === "undefined" || !console.log) return;

    const heading =
        "font: italic 700 22px/1 'Newsreader', Georgia, serif;" +
        "color: #f7f3ec; background: #2a2520;" +
        "padding: 8px 14px; border-radius: 2px;";

    const quote =
        "font: italic 16px/1.4 'Newsreader', Georgia, serif;" +
        "color: #2a2520;";

    const cite =
        "font: 12px/1.4 ui-monospace, 'JetBrains Mono', Menlo, monospace;" +
        "letter-spacing: 0.14em; text-transform: uppercase;" +
        "color: #6a635c;";

    const credit =
        "font: 11px/1.5 ui-monospace, 'JetBrains Mono', Menlo, monospace;" +
        "color: #948c84;";

    console.log("%c grantgiles.com.au ", heading);
    console.log(
        "%c\n“Train the body. Starve the mind, and it all stops working.”\n",
        quote
    );
    console.log("%c● Coaching notebook · 2019\n", cite);
    console.log(
        "%cTwo pillars, six ways in.\n" +
            "Built by hand in Brunswick Heads.\n\n" +
            "Source:  github.com/pureflo/grant-giles-2026\n" +
            "Hello:   grant@aeromaxteam.com\n",
        credit
    );
}
